import { analytics } from '@saucelabs/sl-util-axios';

/**
 * @param {Object} params
 * @param {array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getFailureTests(params) {
  return analytics.get('/tests/names', { params });
}
